// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Grid } from '@mui/material';
import { ReactElement } from 'react';

export type OptionsEditorGridProps = {
  /**
   * 1-3 `OptionsEditorColumn` components to render content in columns.
   */
  children: React.ReactNode;
};

/**
 * Top level grid container used to lay out content for editing in panel
 * options.
 */
export const OptionsEditorGrid = ({ children }: OptionsEditorGridProps): ReactElement => {
  return (
    <Grid container spacing={8}>
      {children}
    </Grid>
  );
};
